<template>
    <!-- 新增的表单内容 -->
    <div>
        <ut-form-item>
            <template slot="label">
                <span style="color:red">*</span>目标监控URL:
            </template>
            <ut-input class="demo-input" v-model.trim="newUrl" :style="{width:inputWidth}" @focus="urlFocus" @blur="urlBlur">
            <template slot="addonBefore" :style="{width:'100px'}">
                <ut-select v-model="currentValue.requestType" class="demo-input-select" :style="{width:'100px'}">
                    <ut-option
                    v-for="item in reqTypeData"
                    :value="item.value"
                    :key="item.value"
                    :label="item.label"
                    ></ut-option>
                </ut-select>
            </template>
        </ut-input>
        </ut-form-item>
        <!-- 请求的body参数，除get和head之外的请求方式都有 -->
        <ut-form-item label="请求body参数:"  class="ace-container1" style="width:700px;" v-show="currentValue.requestType!==0&&currentValue.requestType!==2">
            <div class="ace-editor1" ref="ace" ></div>
            <ut-button @click="aceFormat" class="format" size="small" type='primary' v-show="currentValue.requestType!==0&&currentValue.requestType!==2">格式化body</ut-button>
        </ut-form-item>
        <!-- 请求参数，query和headers -->
        <ut-form-item label="其他请求参数：">
        <div class="paramsBox">
            <ut-radio-group v-model='paramType'>
                <ut-radio-button value='Query'>Query</ut-radio-button>
                <ut-radio-button value='Headers'>Headers</ut-radio-button>
                <ut-radio-button value='Auth'>Basic Auth</ut-radio-button>
            </ut-radio-group>
                <div class="queryBox" v-if="paramType==='Query'">
                    <ut-button class="addQuery" type='primary' @click="addQuery">添加query参数</ut-button>
                    <div class="queryList" v-for="(name,idx) in currentValue.querys" :key='name[value]'>
                        <ut-input placeholder='参数名称'  v-model.trim="name.key"></ut-input>
                        <ut-input placeholder='参数值' v-model.trim="name.value"></ut-input>
                        <icon :size=17 name="delete" @click.native="removeQuery(idx)"></icon>
                    </div>
                </div>
                <div class="authBox" v-else-if="paramType==='Auth'">
                  <div class="auth">
                    <span class="label">账号：</span>
                    <ut-input placeholder="请输入账号" style="width:500px;margin-bottom:15px;" v-model="currentValue.user"></ut-input>
                  </div>
                  <div class="auth">
                    <span class="label">密码：</span>
                    <ut-input placeholder="请输入密码" :type="type" @focus="type='password'" style="width:500px;" v-model="currentValue.password"></ut-input>
                  </div>

                </div>
                <div class="headersBox" v-else>
                    <ut-button type='primary' class="addHeader" @click="addHeader">添加header参数</ut-button>
                    <div class="headersList" v-for="(name,idx) in currentValue.headers" :key='name[value]'>
                        <ut-dropdown>
                            <ut-input placeholder="参数名称" v-model="name.key"></ut-input>
                            <div slot='dropdown' style="height:200px;overflow:auto;">
                                <ut-dropdown-item
                                    @click.native="name.key=header"
                                    :key="header"
                                    v-for="header in autoComplete.filter(val=>val.includes(name.key))">{{header}}</ut-dropdown-item>

                            </div>
                        </ut-dropdown>
                        <ut-dropdown>
                          <ut-input placeholder="参数值" v-model="name.value"></ut-input>
                          <div slot='dropdown' style="height:150px;overflow:auto;">
                                <ut-dropdown-item
                                    @click.native="name.value=headerInfo"
                                    :key="headerInfo"
                                    v-for="headerInfo in contentTypeList.filter(val=>val.includes(name.value))">{{headerInfo}}</ut-dropdown-item>

                          </div>
                        </ut-dropdown>

                        <icon :size=17 name="delete" @click.native="removeHeader(idx)"></icon>
                    </div>
                </div>
        </div>
        </ut-form-item>
    </div>
</template>
<script>
import ace from 'ace-builds'
import 'ace-builds/webpack-resolver' // 在 webpack 环境中使用必须要导入
import 'ace-builds/src-noconflict/theme-monokai' // 默认设置的主题
import 'ace-builds/src-noconflict/mode-javascript' // 默认设置的语言模式
export default {
  props: ['value'],
  data () {
    return {
      type: 'text', // 密码框格式方式
      inputWidth: '500px',
      currentValue: {},
      // 编辑器部分
      aceEditor: null,
      themePath: 'ace/theme/monokai', // 不导入 webpack-resolver，该模块路径会报错
      modePath: 'ace/mode/javascript', // 同上
      // 请求方式
      requestType: '',
      // 请求方式列表
      reqTypeData: [
        { value: 0, label: 'GET' },
        { value: 1, label: 'POST' },
        { value: 2, label: 'HEAD' },
        { value: 3, label: 'PUT' },
        { value: 4, label: 'DELETE' }
      ],
      contentTypeList: ['application/json', 'application/x-www-form-urlencoded', 'application/atom+xml', 'application/octet-stream', 'application/svg+xml', 'application/xhtml+xml', 'multipart/form-data', 'application/xml', 'text/html', 'text/xml', 'text/plain', '*/*'],
      paramType: 'Query', // Query或者Headers
      urlIsFocus: false, // url输入框是否聚焦
      //   headers选项值
      autoComplete: ['Content-Type', 'Accept', 'Set-Cookie', 'Accept-Charset', 'Accept-Encoding', 'Accept-Language', 'Accept-Datetime', 'Authorization', 'Cache-Control', 'Connection', 'Cookie', 'Content-Disposition', 'Content-Length', 'Content-MD5', 'Date', 'Expect', 'From', 'Host', 'If-Match', 'If-Modified-Since', 'If-None-Match', 'If-Range', 'If-Unmodified-Since', 'Max-Forwards', 'Origin', 'Pragma', 'Proxy-Authorization', 'Range', 'Referer', 'TE', 'User-Agent', 'Upgrade', 'Via', 'Warning', 'X-Requested-With', 'DNT', 'X-Forwarded-For', 'X-Forwarded-Host', 'X-Forwarded-Proto', 'Front-End-Https', 'X-Http-Method-Override', 'X-ATT-DeviceId', 'X-Wap-Profile', 'Proxy-Connection', 'X-UIDH', 'X-Csrf-Token']
    }
  },
  computed: {
    newUrl: {
      // get时，将地址url和querys参数拼接一起放到url上边
      get () {
        let that = this
        if (!this.currentValue.url) return
        // 拿到url
        let res = this.currentValue.url.split('?')[0]
        // 存在querys的情况下，循环拼接进去
        if (!this.currentValue.querys || this.currentValue.querys.length < 1) {
          if (res.length <= 50) {
            that.inputWidth = '500px'
          } else {
            that.inputWidth = res.length * 10 + 'px'
          }
          return res
        }
        // 拿到query
        let queryStr = ''
        this.currentValue.querys.forEach((val, index) => {
          // key值不为空的时候再添加
          let strKey = val.key
          let strValue = val.value
          if (strKey.length > 0) {
            let str = ''
            if (this.urlIsFocus === true) {
              if (index === (this.currentValue.querys.length - 1) && strValue.length === 0) {
                str = strKey + '&'
              } else {
                str = strKey + '=' + strValue + '&'
              }
            } else {
              str = strKey + '=' + strValue + '&'
            }
            queryStr += str
          }
        })
        if (queryStr.indexOf('&') !== -1) {
          queryStr = queryStr.slice(0, queryStr.length - 1)
        }
        if (this.currentValue.querys.length > 0) {
          res += '?' + queryStr
        } else {
          res += queryStr
        }
        // 计算输入框宽度
        if (res.length <= 50) {
          that.inputWidth = '500px'
        } else {
          that.inputWidth = res.length * 10 + 'px'
        }
        return res
      },
      //   url地址改变时，执行set下的操作，修改querys里边的数组
      set (val) {
        if (val === undefined || val.length === 0) {
          this.currentValue.url = ''
          this.currentValue.querys = []
          return
        } else if (val.indexOf('?') === -1) {
          this.currentValue.querys = []
        }
        if (val.length <= 50) {
          this.inputWidth = '500px'
        } else {
          this.inputWidth = val.length * 10 + 'px'
        }
        // 问题经常出现在此处,取url值循环出querys参数
        if (!this.checkURL(val)) return
        const uri = new URL(val)
        this.currentValue.url = val.split('?')[0]
        let queryStr = uri.search.replace('?', '')

        let querysList
        let dataList = []
        if (queryStr.replace(/(^s*)|(s*$)/g, '').length === 0) { // 参数为空
          querysList = []
        } else { // 参数不为空
          this.currentValue.querys = []
          querysList = queryStr.split('&')
          for (let i = 0; i < querysList.length; i++) {
            let key = querysList[i].split('=')[0]
            let value = querysList[i].split('=').length > 1 ? querysList[i].split('=')[1] : ''
            dataList.push({ key, value })
          }
          this.currentValue.querys = dataList
        }
      }
    }
  },
  mounted () {
    this.initData()
  },
  watch: {

    'currentValue': {
      deep: true,
      handler (n) {
        this.$emit('input', n)
      }
    },
    'value' (to, from) { // 第一次取值时改变
      if (JSON.stringify(this.value) !== JSON.stringify(this.currentValue)) {
        this.initData()
      }
    },
    'aceEditor' (to, from) {
      if (to !== null) {
        if (this.currentValue.postContent === '') return
        let parsed = ''
        try {
          parsed = JSON.parse(this.currentValue.postContent)
        } catch (err) {
          this.$message.error('非法的body参数')
          return
        }
        var val = JSON.stringify(parsed, null, 2)
        this.aceEditor.setValue(val)
        this.aceEditor.clearSelection()// 取消选中
      }
    },
    // 是否显示body输入框
    'currentValue.requestType' (to, from) {
      if (to === 0 || to === 2) { // get或者head的请求方式，不需要body,
        this.aceEditor = null
      } else { // 其他情况下都需要body
        this.aceEditor = ace.edit(this.$refs.ace, {
          maxLines: 30, // 最大行数，超过会自动出现滚动条
          minLines: 10, // 最小行数，还未到最大行数时，编辑器会自动伸缩大小
          fontSize: 14, // 编辑器内字体大小
          theme: this.themePath, // 默认设置的主题
          mode: this.modePath, // 默认设置的语言模式
          tabSize: 4// 制表符设置为 4 个空格大小
        })
        this.aceEditor.getSession().on('change', this.change)
      }
    },
    'currentValue.password' (to, from) {
      if (to.trim().length !== 0) {
        this.type = 'password'
      }
    }
  },
  methods: {
    urlFocus () {
      this.urlIsFocus = true
    },
    urlBlur () {
      this.urlIsFocus = false
    },
    // 判断url地址是否合法
    checkURL (URL) {
      var str = URL
      var Expression = /http(s)?:\/\/([\w-]+\.)+[\w-]+(\/[\w- .\/?%&=]*)?/
      var objExp = new RegExp(Expression)
      if (objExp.test(str) === true) {
        return true
      } else {
        return false
      }
    },
    // 初始化数据，拿到原始数据变换后赋到新值
    initData () {
      const data = {}
      for (const key in this.value) {
        if (['headers', 'querys'].indexOf(key) === -1) { // 不是headers和querys
          data[key] = this.value[key]
        } else { // 是headers和querys
          if (typeof this.value[key] === 'string' || typeof this.value[key] === 'undefined' || typeof this.value[key] === 'object') {
            data[key] = Object.entries(JSON.parse(this.value[key] || '{}')).map(val => {
              return {
                key: val[0],
                value: val[1]
              }
            })
          }
        }
      }

      this.currentValue = data
    },
    change () {
      this.currentValue.postContent = this.aceEditor.getSession().getValue().replace(/\s+/g, '')
    },
    //   添加query参数点击
    addQuery () {
      this.currentValue.querys.push({
        key: '',
        value: ''
      })
    },
    //   添加header参数点击
    addHeader () {
      this.currentValue.headers.push({
        key: '',
        value: ''
      })
    },
    //   删除query图标点击
    removeQuery (idx) {
      this.currentValue.querys.splice(idx, 1)
    },
    // 删除header图标点击
    removeHeader (idx) {
      this.currentValue.headers.splice(idx, 1)
    },
    // 将编辑器内容格式化
    aceFormat () {
      if (this.currentValue.postContent === '') {
        this.$message.error('body参数为空')
        return
      }
      let parsed = ''
      try {
        parsed = JSON.parse(this.currentValue.postContent)
      } catch (err) {
        this.$message.error('非法的body参数')
        return
      }
      var val = JSON.stringify(parsed, null, 2)
      this.aceEditor.setValue(val)
      this.aceEditor.clearSelection()// 取消选中
    }
  }
}
</script>
<style lang="less">
    .ace-container1{
      position: relative;
      .format{
        position: absolute;
        top:0px;
        right:-90px;
        cursor: pointer;
      }
    }
    .paramsBox{
        .utear-radio-group{
            margin-left:15px;
            padding-top:20px;
        }
        .authBox{
            padding-top:15px;
            padding-bottom: 15px;
            .auth{
              overflow: hidden;
              .label{
                float:left;
                padding-left:15px;
              }
              .utear-input{
                float:left;
                width:300px !important;
              }
            }
        }
        .queryBox,.headersBox,.authBox{
            background: #eeeeee;
            width:900px;
            .addQuery,.addHeader{
                margin-top:15px;
                margin-left:15px;
                margin-bottom: 15px;
            }
            .queryList,.headersList{
                display: flex;
                .utear-select{
                    background:white;
                }
                > *{
                    margin-left:15px;
                    margin-bottom: 15px;
                }
                .utear-pro-icon{
                    cursor: pointer;
                }
                .utear-pro-icon:hover{
                    color:tomato;
                }
            }
        }
    }
</style>
